import styled from 'styled-components';

import { tokens } from '@vimeo/ui/tokens';

import { breakpoints } from '../../constants';

const Container = styled.div`
  box-sizing: border-box;
  padding: 0 ${tokens.space.page.xxs};
  margin: 0 auto;
  @media (min-width: ${breakpoints.tablet}) {
    padding: 0 ${tokens.space.page.sm};
  }
  @media (min-width: ${breakpoints.desktop}) {
    padding: 0 ${tokens.space.page.xxl};
  }
`;

export default Container;
